import React from 'react';
import { Clock, ChevronDown } from 'lucide-react';

export interface TimerStyle04Props {
  value?: string;
  options: string[];
  disabled?: boolean;
  loading?: boolean;
  onChange: (value: string) => void;
  label?: string;
  labels?: Record<string, string>;
}

// Default timer display translations
const DEFAULT_TIMER_LABELS: Record<string, string> = {
  '0': '關閉',
  '1': '1 小時',
  '2': '2 小時',
  '3': '3 小時',
  '4': '4 小時',
  '5': '5 小時',
  '6': '6 小時',
  '7': '7 小時',
  '8': '8 小時',
  '9': '9 小時',
  '10': '10 小時',
  '11': '11 小時',
  '12': '12 小時',
  '24': '24 小時'
};

/**
 * Timer Style 04 - Dropdown Select
 * Compact dropdown selector for timer options
 */
export const Style04_Dropdown: React.FC<TimerStyle04Props> = ({
  value = '0',
  options,
  disabled = false,
  loading = false,
  onChange,
  label = '定時關機',
  labels = DEFAULT_TIMER_LABELS
}) => {
  const getTimerLabel = (timer: string): string => {
    return labels[timer] || DEFAULT_TIMER_LABELS[timer] || `${timer} 小時`;
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <Clock className="w-4 h-4 text-purple-400" />
        <span className="text-sm font-medium text-slate-300">{label}</span>
      </div>
      <div className="relative">
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled || loading}
          className={`w-full appearance-none bg-slate-800/70 border border-slate-600 rounded-xl 
            px-4 py-3 pr-10 text-sm text-slate-200
            focus:outline-none focus:ring-2 focus:ring-purple-500/50 focus:border-purple-500
            hover:bg-slate-700/70 transition-colors
            ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
        >
          {options.map((timer) => (
            <option 
              key={timer} 
              value={timer}
              className="bg-slate-800 text-slate-200"
            >
              {loading && value === timer ? '載入中...' : getTimerLabel(timer)}
            </option>
          ))}
        </select>
        <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
          <ChevronDown className={`w-5 h-5 text-slate-400 transition-transform ${loading ? 'animate-pulse' : ''}`} />
        </div>
      </div>
      {/* Current selection indicator */}
      <div className="flex items-center justify-between text-xs text-slate-500">
        <span>目前設定</span>
        <span className={`font-medium ${value !== '0' ? 'text-purple-400' : 'text-slate-400'}`}>
          {getTimerLabel(value)}
        </span>
      </div>
    </div>
  );
};

export default Style04_Dropdown;
